import { useEffect, useState } from 'react';

import { readPropertyValue } from '../targetResolvers.ts';
import type { EditPatch, EditableDescriptor } from '../types.ts';

import { ColorPicker } from './ColorPicker.tsx';

type ColorPopupProps = {
	descriptor: EditableDescriptor;
	iframeDoc: Document;
	brandColors?: string[] | null;
	onApplyEdit: (
		descriptor: EditableDescriptor,
		patch: Partial<EditPatch>,
	) => void;
};

export const ColorPopup = ({
	descriptor,
	iframeDoc,
	brandColors,
	onApplyEdit,
}: ColorPopupProps) => {
	const element = iframeDoc.getElementById(descriptor.id);
	const currentValue =
		(element
			? readPropertyValue(element, descriptor.role, 'backgroundColor')
			: null) ?? '#ffffff';

	const [bgHex, setBgHex] = useState(currentValue);

	// Resync when switching to a different element
	useEffect(() => {
		setBgHex(currentValue);
	}, [descriptor.id]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<ColorPicker
			label="Background Color"
			value={bgHex}
			onChange={(hex) => {
				setBgHex(hex);
				onApplyEdit(descriptor, { backgroundColor: hex });
			}}
			brandColors={brandColors}
		/>
	);
};
